// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border: 1px solid var(--ion-item-border-color);
}
ion-item ion-select {
  width: 100%;
}

ion-modal {
  --width: 290px;
  --height: 400px;
  --border-radius: 8px;
}

ion-item.checkbox {
  border: 0;
  --background: transparent;
  /* ion-checkbox {
      margin-right: 10px;
      --border-color-checked: transparent;
      width: 26px;
      height: 26px;
      --border-radius: 5px;
  } */
}
ion-item.checkbox ion-label {
  white-space: inherit;
}

.page-divider {
  border: 1px solid #ECECEC;
  width: 295px;
  height: 0px;
  margin: 0 auto;
  margin-top: 35px;
  margin-bottom: 35px;
}

.show_quantity_as {
  background: transparent;
}
.show_quantity_as ion-item {
  border: 0;
  --background: transparent;
}

ion-list {
  border-radius: 10px;
}

.button-clear {
  --color: #5DEFBA;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  text-align: center;
  text-transform: capitalize;
}

.remove-btn {
  --color: #FF8686;
}

ion-grid {
  box-shadow: unset;
  background: transparent;
}
ion-grid ion-row {
  align-items: center;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/invoices/create/create.page.scss"],"names":[],"mappings":"AAAA;EACI,8CAAA;AACJ;AACI;EACI,WAAA;AACR;;AAEA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AACJ;;AAEA;EACI,SAAA;EACA,yBAAA;EAMA;;;;;;KAAA;AAEJ;AANI;EACI,oBAAA;AAQR;;AAIA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,uBAAA;AADJ;AAEI;EACI,SAAA;EACA,yBAAA;AAAR;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,kBAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,uBAAA;AAFJ;AAGI;EACI,mBAAA;EACA,SAAA;AADR","sourcesContent":["ion-item {\n    border: 1px solid var(--ion-item-border-color);\n    // --min-height: 16px;\n    ion-select {\n        width: 100%;\n    }\n}\nion-modal {\n    --width: 290px;\n    --height: 400px;\n    --border-radius: 8px;\n}\n\nion-item.checkbox {\n    border: 0;\n    --background: transparent;\n\n    ion-label {\n        white-space: inherit;\n    }\n\n    /* ion-checkbox {\n        margin-right: 10px;\n        --border-color-checked: transparent;\n        width: 26px;\n        height: 26px;\n        --border-radius: 5px;\n    } */\n}\n\n.page-divider {\n    border: 1px solid #ECECEC;\n    width: 295px;\n    height: 0px;\n    margin: 0 auto;\n    margin-top: 35px;\n    margin-bottom: 35px;\n}\n\n.show_quantity_as {\n    background: transparent;\n    ion-item {\n        border: 0;\n        --background: transparent;\n    }\n}\n\nion-list {\n    border-radius: 10px;\n}\n\n.button-clear {\n    --color: #5DEFBA;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    /* identical to box height, or 150% */\n\n    text-align: center;\n    text-transform: capitalize;\n}\n\n.remove-btn {\n    --color: #FF8686;\n}\n\nion-grid {\n    box-shadow: unset;\n    background: transparent;\n    ion-row {\n        align-items: center;\n        border: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
